import { useState, useCallback } from 'react'

/**
 * How long a toast stays up, by what it has to say.
 *
 * Everything used to go after 3.2 seconds, errors included — which is long
 * enough to notice a success and far too short to read a failure. eBay's
 * refusals are a sentence or two and name the listing, and by the time a
 * seller has looked up from what they were doing the message has gone, with
 * no way to get it back.
 */
const DISMISS_MS = {
  // Long enough to read twice and copy the part that matters.
  error:   30000,
  warning: 30000,
  success: 3200,
  info:    3200,
}

export function useToast() {
  const [toasts, setToasts] = useState([])

  const dismiss = useCallback(id => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  const addToast = useCallback((type, message) => {
    // Counter, not a bare timestamp. Two toasts raised in the same
    // millisecond shared an id, so dismissing one removed both — easy to do
    // when a bulk action reports several failures at once, which is exactly
    // when the messages matter.
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
    setToasts(prev => [...prev, { id, type, message }])
    const ms = DISMISS_MS[type] ?? 3200
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), ms)
  }, [])

  return { toasts, addToast, dismiss }
}
